import Chrysler from '@carvana/ds-icons/Chrysler';
import Jeep from '@carvana/ds-icons/Jeep';
import RamHorizontal from '@carvana/ds-icons/RamHorizontal';
import DodgeIcon from '~/icons/new-car/DodgeIcon';

const makeIcons: Record<string, typeof Chrysler> = {
  Chrysler,
  Jeep,
  Ram: RamHorizontal
};

type OwnProps = {
  make: string;
  size: number;
};

export default function BrandCardIcon({ make, size }: OwnProps) {
  if (make === 'Dodge') {
    return (
      <DodgeIcon
        aria-label="Dodge logo"
        className="block"
        role="img"
        style={{ width: size, height: size }}
      />
    );
  }

  const MakeIcon = makeIcons[make];

  if (!MakeIcon) {
    return null;
  }

  return (
    <MakeIcon
      aria-label={make}
      className="block"
      role="img"
      style={{ width: size, height: size }}
    />
  );
}
